import angular from 'angular';
import { ColaboradoresResultadoTableController } from './colaboradores-resultado-table.controller';

export class ColaboradoresResultadoTableComponent implements angular.IComponentOptions {
    static selector = 'colaboradoresResultadoTableComponent';
    static controller = ColaboradoresResultadoTableController;
    static template = require('!!html-loader!./colaboradores-resultado-table.html');
    static transclude = true;
    static bindings = {
        items: '<',
        showSelection: '<',
        selectedItems: '=?',
        onSelectionChange: '&?',
    };
}
